import { DEFAULT_PAGE } from 'utils'

interface AppTypeConfig {
  defaultPage: string
  showSsoLogin: boolean
}

const config: AppTypeConfig = {
  defaultPage: DEFAULT_PAGE,
  showSsoLogin: false,
}

export default config
